/**
 * Check if a booking can be canceled based on time constraints
 * @param {Object} slot - The slot object containing date_time property
 * @returns {boolean} - Whether the booking can be canceled
 */
export const cancelBookingIsAvailable = (targetTime) => {
  const currentTime = new Date();
  const exerciseTime = new Date(targetTime);

  // If target time is after tomorrow's end of day
  const tomorrow = new Date();
  tomorrow.setDate(currentTime.getDate() + 1);
  tomorrow.setHours(23, 59, 59, 999); // End of tomorrow

  if (exerciseTime > tomorrow) {
    return true;
  }

  // If target time is after tomorrow and current time is before 18:00
  const nextDay = new Date();
  nextDay.setDate(currentTime.getDate() + 1);
  nextDay.setHours(0, 0, 0, 0);

  if (exerciseTime > nextDay && currentTime.getHours() < 18) {
    return true;
  }

  return false;
};
